
export const REDUCER_NAME = 'deletedUsers';

export interface DeletedUser {
  userId: string;
  email: string;
  deletedAt: string;
}

export interface DeletedUserState {
  deletedUsersList: DeletedUser[];
  isLoading: boolean;
  error: string | null;
}